export default class SubscriptionPlan
{
    id = ""
    name = ""
    description = ""
    price = 0
    billingCycle = 0
}